export default __webpack_public_path__ + "static/media/_DUA6487.3793477d.jpg";